<template>
  <div :class="layoutClass">
    <Toast/>
    <div class="p-grid p-jc-center login-box">
      <div :class="boxClass">
        <div class="center-component">
          <h3>Login</h3>
          <span class="p-float-label p-mb-2">
              <div class="p-inputgroup">
                  <span class="p-inputgroup-addon">
                      <i class="pi pi-user"></i>
                  </span>
                  <InputText name="username" v-model="username" placeholder="Username"/>
              </div>
          </span>
          <span class="p-float-label p-mb-2">
              <div class="p-inputgroup">
                  <span class="p-inputgroup-addon">
                      <i class="pi pi-key"></i>
                  </span>
                  <InputText name="password" v-model="password" type="password" placeholder="password"/>
              </div>
          </span>
          <span class="p-float-label p-mb-4">
              <div class="p-inputgroup">
                  <a href="/forgot">Forgot Password</a>
              </div>
          </span>
          <span class="p-float-label">
              <div class="p-inputgroup">
                  <Button :class="btnClass" label="Login" @click="onClick"/>
              </div>
          </span>
        </div>
      </div>
      <div class="p-col-4 login-box-right remove-on-mobile">
      </div>
    </div>
  </div>

</template>

<script>
  import router from "../router";
  import LoginService from '../services/LoginService';

  export default {
    data() {
      return {
        username: "",
        password: "",
        token_info: {},
      };
    },
    methods: {
      onClick() {
        this.loginService.login(this.username, this.password).then(result => {
          if (result.status === 200) {
            let data = result.data.data;
            this.token_info = data.token_info;

            localStorage.setItem("token", this.token_info.access_token);
            this.$store.state.token = this.token_info.access_token;

            localStorage.setItem("user_info", JSON.stringify(data.user_info));
            this.$store.state.user_info = JSON.stringify(data.user_info);

            this.$store.state.accesses = data.accesses;
            router.push("/dashboard");
          } else {
            this.$toast.add({
              severity: 'warn',
              summary: 'Failed to login!',
              detail: result.data.error
            });
          }
        });
      }
    },
    loginService: null,
    created() {
      this.loginService = new LoginService();
    },
    computed: {
      layoutClass() {
        return ['login', {
          'login-dark': this.$store.state.theme === 'dark',
          'login-light': this.$store.state.theme === 'light',
        }];
      },
      boxClass() {
        return ['p-sm-12 p-md-8 p-lg-8 login-box-left', {
          'login-box-dark': this.$store.state.theme === 'dark',
          'login-box-light': this.$store.state.theme === 'light',
        }];
      },
      btnClass() {
        return ['login-button', {
          'p-button-info': this.$store.state.theme === 'dark',
          'p-button-success': this.$store.state.theme === 'light',
        }];
      },
    },

  }
</script>

<style scoped>

</style>
